module.exports = __webpack_public_path__ + "0435406c1e02480c6346fd35182830af.mp4";